<xemex-dialog-shell
  [title]="
    ('devices.detailTabs.configuration.titleChannelClear' | translate) + ' #' + channelNumber
  "
>
  <div class="border border-border-card rounded-lg p-2">
    <span>{{ 'devices.detailTabs.configuration.clearConfigurationText' | translate }}</span>
  </div>
  @if (clearError) {
    <span class="text-red-500 text-sm max-w-sm">{{ clearError }}</span>
  }
  <div actions>
    <xemex-text-button type="button" intent="primary" [disabled]="isClearing" (click)="dialogRef.close()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button
      type="button"
      intent="destructive"
      [loading]="isClearing"
      [disabled]="isClearing"
      (click)="onClear()"
    >
      @if (isClearing) {
        <xemex-spinner size="sm"></xemex-spinner>
      } @else {
        {{ 'devices.detailTabs.configuration.buttonClearDeviceConfiguration' | translate }}
      }
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
